import { useContext } from "react"
import utility from "src/utils/utility"
import { useNavigate } from "react-router-dom"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import UserContext from "src/provider/state-manager/userProvider"
import {browserName, mobileModel} from 'react-device-detect'
import { AppSpan, AppText, Button, GridContainer, Icon, ScreenContainer } from "src/style"
import ProfileCompletionGif from 'src/assets/gif/success.gif'
import {ReactComponent as ProfileCompletionIcon} from 'src/assets/img/success-icon-safari.svg'
import Lottie from "lottie-react";
import successGif from "src/assets/gif/success.json";

export const ProfileCompletionD1 = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {onboardingInput}} = useContext(UserContext)

    async function handleProceed () {
        const payload = {
            username: onboardingInput?.username,
            password: onboardingInput?.password
        }
        const response = await API.login(payload)
        if (response) navigate('/dashboard/home')
    }

    return (
        <ScreenContainer padding='2.5'>
            <GridContainer 
                height="100" hUnit="%"
            >
                <GridContainer width="30" topMargin="-10">
                    <GridContainer width="20" sizeUnit="">
                        {/* { (browserName != 'Safari' && mobileModel != 'iPhone') ?
                            <Icon src={ProfileCompletionGif} />
                            : <ProfileCompletionIcon className="icon-component" />
                        } */}
                        <Lottie animationData={successGif} loop={true} />
                    </GridContainer>
                    <AppText 
                        textSize="2.2" fontWeight="700" fontFamily="Gilmer-Bold" 
                        align="center"
                    >
                        Profile Creation Successful
                    </AppText>
                    <AppText 
                        textSize="2.2" fontWeight="700" fontFamily="Gilmer-Bold" 
                        bottomMargin="2.5" align="center"
                    >
                        Welcome to {institutionData?.name}!
                    </AppText>
                    <Button 
                        width='18.2' topMargin='6' 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F' titleSize="1.4"
                        onClick={() => navigate('/login')}
                    >
                        Proceed to Login
                    </Button>
                </GridContainer>
            </GridContainer>
        </ScreenContainer>
    )
}